// Carousel: optional classes on .slides-wrapper or .slides-blocks
// - slide-no-arrows — no prev/next wiring
// - slide-no-active-arrows — hide prev/next at scroll edges (when disabled); omit to keep them visible (disabled only)
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.slides-wrapper').forEach(wrapper => {
      const scroller = wrapper.querySelector('.slides-blocks');
      const prev = wrapper.querySelector('.carousel-btn.prev');
      const next = wrapper.querySelector('.carousel-btn.next');
      if (!scroller) return;

      /* ── RE-ENTRANCY GUARD (Shopify port) ─────────────────────────────────────────
         Two home sections load this file (press and reviews), and duplicate classic
         <script src> tags execute once per tag — they are not de-duplicated the way
         modules are. Without this, every wrapper got its listeners bound twice, so one
         arrow click advanced two slides. The flag is per wrapper element so the
         editor's reinject still binds freshly swapped sections.

         The flag name differs from the one in nooa-slider.js on purpose. The two files
         are NOT interchangeable — they diverge in behaviour — and each guards only its
         own re-execution. No page loads both today (this file serves press, reviews and
         app advantages; nooa-slider.js serves the three Band LP sliders). */
      if (wrapper.__nooaSliderTemplateBound) return;
      wrapper.__nooaSliderTemplateBound = true;
      const slideHasClass = (cls) =>
        wrapper.classList.contains(cls) || scroller.classList.contains(cls);
      const hasArrows = !slideHasClass('slide-no-arrows');
      const hideInactiveArrows = slideHasClass('slide-no-active-arrows');
      const hasAutoplay = wrapper.classList.contains('slide-autolpay') || scroller.classList.contains('slide-autolpay');
      const autoplayInterval = Number(wrapper.dataset.autoplayInterval || scroller.dataset.autoplayInterval || 2500);
      let autoplayTimer = null;
      let autoplayResumeTimer = null;
      
      // Mouse drag functionality for desktop
      let isDragging = false;
      let isMouseDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let initialScrollLeft = 0;
      let wasDragging = false; // Track if dragging occurred to prevent click events
      let rafId = null;
      
      scroller.addEventListener('mousedown', (e) => {
        // Don't start dragging if clicking directly on a carousel button
        if (e.target.closest('.carousel-btn')) return;
        
        isMouseDown = true;
        wasDragging = false;
        startX = e.pageX;
        initialScrollLeft = scroller.scrollLeft;
        scrollLeft = scroller.scrollLeft;
      });
      
      scroller.addEventListener('mouseleave', () => {
        if (isDragging) {
          isDragging = false;
          scroller.style.cursor = 'grab';
          scroller.style.userSelect = '';
          scroller.classList.remove('is-dragging');
          if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = null;
          }
          updateButtons();
        }
        isMouseDown = false;
      });
      
      const handleMouseUp = (e) => {
        if (isDragging) {
          isDragging = false;
          scroller.style.cursor = 'grab';
          scroller.style.userSelect = '';
          scroller.classList.remove('is-dragging');
          wasDragging = true;
          e.preventDefault();
          e.stopPropagation();
          
          if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = null;
          }
          
          // Update buttons after dragging ends
          updateButtons();
          
          // Prevent accidental click events right after drag
          setTimeout(() => {
            wasDragging = false;
          }, 100);
        } else {
          wasDragging = false;
        }
        isMouseDown = false;
      };
      
      const handleMouseMove = (e) => {
        if (!isMouseDown) return;
        
        const x = e.pageX;
        const diff = Math.abs(x - startX);
        
        // Only start dragging if mouse moved more than 5px (prevents accidental drag on clicks)
        if (!isDragging && diff > 5) {
          isDragging = true;
          wasDragging = true;
          scroller.style.cursor = 'grabbing';
          scroller.style.userSelect = 'none';
          scroller.classList.add('is-dragging');
          // Recalculate start position when dragging actually starts
          startX = x;
          scrollLeft = initialScrollLeft;
        }
        
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
          
          const walk = x - startX;
          scroller.scrollLeft = scrollLeft - walk;
        }
      };
      
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('mousemove', handleMouseMove);
      
      // Prevent native browser image dragging inside carousel
      scroller.addEventListener('dragstart', (e) => {
        if (e.target.closest('img')) {
          e.preventDefault();
        }
      });
      
      // Set initial cursor style
      scroller.style.cursor = 'grab';
      
      function getGap() {
        const style = window.getComputedStyle(scroller);
        const gap = parseFloat(style.columnGap || style.gap || '0');
        return isNaN(gap) ? 0 : gap;
      }
      function getScrollAmount() {
        const first = scroller.querySelector('.slide-wrapper');
        if (first) {
          const rect = first.getBoundingClientRect();
          return Math.ceil(rect.width + getGap()) || 300;
        }
        return 300;
      }
      function atStart() { return Math.round(scroller.scrollLeft) <= 1; }
      function atEnd() {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth - 1;
        return Math.round(scroller.scrollLeft) >= maxScroll;
      }
      function autoAdvance() {
        if (isDragging || isMouseDown) return;
        if (atEnd()) {
          scroller.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scroller.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        }
        setTimeout(updateButtons, 300);
      }
      function startAutoplay() {
        if (!hasAutoplay || autoplayTimer) return;
        autoplayTimer = setInterval(autoAdvance, autoplayInterval);
      }
      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }
      function scheduleAutoplayResume(delay = 5000) {
        if (!hasAutoplay) return;
        stopAutoplay();
        if (autoplayResumeTimer) clearTimeout(autoplayResumeTimer);
        autoplayResumeTimer = setTimeout(() => {
          autoplayResumeTimer = null;
          startAutoplay();
        }, delay);
      }
      function updateButtons() {
        if (!hasArrows || !prev || !next) return;
        const start = atStart();
        const end = atEnd();
        prev.disabled = start;
        next.disabled = end;
        if (hideInactiveArrows) {
          prev.style.display = start ? 'none' : '';
          next.style.display = end ? 'none' : '';
        } else {
          prev.style.display = '';
          next.style.display = '';
        }
      }
      if (hasArrows && prev && next) {
        prev.addEventListener('click', () => {
          scheduleAutoplayResume();
          const amount = getScrollAmount();
          const target = Math.max(0, scroller.scrollLeft - amount);
          scroller.scrollTo({ left: target, behavior: 'smooth' });
          setTimeout(updateButtons, 300);
        });
        next.addEventListener('click', () => {
          scheduleAutoplayResume();
          scroller.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
          setTimeout(updateButtons, 300);
        });
      }
      scroller.addEventListener('mousedown', () => {
        scheduleAutoplayResume();
      });
      scroller.addEventListener('touchstart', () => {
        scheduleAutoplayResume();
      }, { passive: true });
      scroller.addEventListener('wheel', () => {
        scheduleAutoplayResume();
      }, { passive: true });
      scroller.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      if (hasArrows && prev) {
        try {
          prev.disabled = true;
          if (hideInactiveArrows) prev.style.display = 'none';
        } catch (e) {}
      }
      updateButtons();
      requestAnimationFrame(updateButtons);
      window.addEventListener('load', updateButtons);
      if (hasAutoplay) {
        startAutoplay();
        wrapper.addEventListener('mouseenter', stopAutoplay);
        wrapper.addEventListener('mouseleave', () => scheduleAutoplayResume(800));
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            stopAutoplay();
          } else {
            scheduleAutoplayResume(300);
          }
        });
      }
    });
  });
  